import { FC, FormEventHandler } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { EducationalStage } from '@les-sherpas/sherpas-toolbox';
import { Typography } from '@mui/material';

import FilterSection from '@/components/Search/components/Filters/common/FilterSection/FilterSection';
import { Checkbox } from '@/designSystem/Form/Checkbox/Checkbox';

import messages from './messages';

type Props = {
  levels: EducationalStage[];
  handleChange: FormEventHandler<HTMLDivElement>;
};

const LevelFilter: FC<Props> = ({ levels, handleChange }) => {
  const { formatMessage } = useIntl();

  return (
    <FilterSection title={formatMessage(messages.title)}>
      <Checkbox
        id={`filter_${EducationalStage.Primaire}`}
        label={
          <Typography variant="bodyMd">
            <FormattedMessage {...messages.primaire} />
          </Typography>
        }
        isChecked={levels.includes(EducationalStage.Primaire)}
        onChange={handleChange}
        name={EducationalStage.Primaire}
      />
      <Checkbox
        id={`filter_${EducationalStage.College}`}
        label={
          <Typography variant="bodyMd">
            <FormattedMessage {...messages.college} />
          </Typography>
        }
        isChecked={levels.includes(EducationalStage.College)}
        onChange={handleChange}
        name={EducationalStage.College}
      />
      <Checkbox
        id={`filter_${EducationalStage.Lycee}`}
        label={
          <Typography variant="bodyMd">
            <FormattedMessage {...messages.lycee} />
          </Typography>
        }
        isChecked={levels.includes(EducationalStage.Lycee)}
        onChange={handleChange}
        name={EducationalStage.Lycee}
      />
      <Checkbox
        id={`filter_${EducationalStage.Prepa}`}
        label={
          <Typography variant="bodyMd">
            <FormattedMessage {...messages.prepa} />
          </Typography>
        }
        isChecked={levels.includes(EducationalStage.Prepa)}
        onChange={handleChange}
        name={EducationalStage.Prepa}
      />
      <Checkbox
        id={`filter_${EducationalStage.Superieur}`}
        label={
          <Typography variant="bodyMd">
            <FormattedMessage {...messages.superieur} />
          </Typography>
        }
        isChecked={levels.includes(EducationalStage.Superieur)}
        onChange={handleChange}
        name={EducationalStage.Superieur}
      />
    </FilterSection>
  );
};

export default LevelFilter;
